<app-perfil-shell [showGreeting]="false" [showSecurityBanner]="false" [skipFooterCms]="true" [sectionViewport]="true">
  <div class="perfil-section-page">
    <div class="perfil-section-page__chrome">
      <app-perfil-steps-strip activa="sobre-ingresos"></app-perfil-steps-strip>
    </div>

    <div class="perfil-section-page__scroll" #sectionScroll>
      <div class="perfil-section-page__scroll-inner">
        <form class="perfil-section-page__panel perfil-section-page__panel--flat" [formGroup]="form"
          (ngSubmit)="onCta()">
          @if (currentStepId === 'activos-soportes' || currentStepId === 'documentos') {
          <div class="perfil-ingresos">
            @if (currentStepId === 'activos-soportes') {
            <div class="perfil-section-page__grid perfil-section-page__grid--2">
              <div class="perfil-field" [class.perfil-field--invalid]="isInvalid('anioActivos')">
                <label class="perfil-field__label" for="anioActivos">{{
                  copy.sobreIngresos.campos.anioActivos
                  }}</label>
                <select id="anioActivos" class="perfil-field__control" formControlName="anioActivos"
                  [class.perfil-field__control--invalid]="isInvalid('anioActivos')">
                  <option value="">{{ copy.sobreIngresos.placeholderSelect }}</option>
                  @for (opt of anios; track opt.value) {
                  <option [value]="opt.value">{{ opt.label }}</option>
                  }
                </select>
                @if (isInvalid('anioActivos')) {
                <p class="perfil-field__error">{{ errorMessage('anioActivos') }}</p>
                }
              </div>

              @if (esJuridica) {
              <div class="perfil-field perfil-field--required"
                [class.perfil-field--invalid]="isInvalid('ventasUltimoAnio')">
                <label class="perfil-field__label" for="ventasUltimoAnio">{{
                  copy.sobreIngresos.campos.ventasUltimoAnio
                  }}</label>
                <input id="ventasUltimoAnio" class="perfil-field__control" type="text" inputmode="numeric"
                  autocomplete="off" formControlName="ventasUltimoAnio"
                  [placeholder]="copy.sobreIngresos.placeholderTexto"
                  [class.perfil-field__control--invalid]="isInvalid('ventasUltimoAnio')"
                  (input)="onVentasUltimoAnioInput($event)" (blur)="onVentasUltimoAnioBlur()" />
                @if (isInvalid('ventasUltimoAnio')) {
                <p class="perfil-field__error">{{ errorMessage('ventasUltimoAnio') }}</p>
                }
              </div>
              }

              <div class="perfil-field perfil-field--required"
                [class.perfil-field--invalid]="isInvalid('valorActivos')"
                [class.perfil-field--span-2]="esJuridica">
                <label class="perfil-field__label" for="valorActivos">{{
                  copy.sobreIngresos.campos.valorActivos
                  }}</label>
                <input id="valorActivos" class="perfil-field__control" type="text" inputmode="numeric"
                  autocomplete="off" formControlName="valorActivos" [placeholder]="copy.sobreIngresos.placeholderTexto"
                  [class.perfil-field__control--invalid]="isInvalid('valorActivos')"
                  (input)="onValorActivosInput($event)" (blur)="onValorActivosBlur()" />
                @if (isInvalid('valorActivos')) {
                <p class="perfil-field__error">{{ errorMessage('valorActivos') }}</p>
                }
              </div>
            </div>
            }

            @if (muestraDocsObligatoriosEnPaso) {
            <div class="perfil-ingresos__docs">
              @for (doc of documentosPasoActivosSinRenta; track doc.valueKey) {
              <div class="perfil-ingresos__doc"
                [class.perfil-ingresos__doc--loaded]="hasDoc(doc.valueKey)"
                [class.perfil-ingresos__doc--invalid]="isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)"
                [class.perfil-ingresos__doc--multi]="doc.multiple">
                <div class="perfil-ingresos__doc-text">
                  <p class="perfil-ingresos__doc-title" [class.perfil-field--required]="doc.obligatorio">
                    <span class="perfil-field__label">{{ labelDoc(doc) }}</span>
                  </p>
                  @if (doc.descripcion) {
                  <p class="perfil-ingresos__doc-desc">{{ doc.descripcion }}</p>
                  }
                </div>

                <div class="perfil-ingresos__doc-slots"
                  [class.perfil-ingresos__doc-slots--multi]="isDocMultiple(doc)">
                  @if (isDocMultiple(doc)) {
                  <div class="perfil-ingresos__doc-multi-head">
                    <span class="perfil-ingresos__doc-multi-hint">{{ multiUploadHint(doc) }}</span>
                    <span class="perfil-ingresos__doc-multi-count">{{ filledSlotsCount(doc) }} de {{ maxSlotsCount(doc) }}</span>
                  </div>

                  @for (slot of filledSlots(doc); track slot.slotKey) {
                  <div class="perfil-ingresos__file-card" role="status"
                    [class.perfil-ingresos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                    [class.perfil-ingresos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                    [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreIngresos.validaciones.documentosInconsistentes) : ''"
                    container="body">
                    <div class="perfil-ingresos__file-icon-wrap">
                      <img class="perfil-ingresos__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                    </div>
                    <div class="perfil-ingresos__file-meta">
                      <div class="perfil-ingresos__file-top">
                        <p class="perfil-ingresos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                        @if (canRemoveSlot(slot.slotKey)) {
                        <button type="button" class="perfil-ingresos__file-remove"
                          [attr.aria-label]="copy.sobreIngresos.archivoQuitar"
                          (click)="removeDoc(slot.slotKey)">
                          <span class="material-icons" aria-hidden="true">close</span>
                        </button>
                        }
                      </div>
                      <p class="perfil-ingresos__file-status">
                        <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                        <span aria-hidden="true"> • </span>
                        <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                      </p>
                      @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                      <p class="perfil-ingresos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                      }
                    </div>
                  </div>
                  }

                  @if (nextEmptySlot(doc); as next) {
                  <div class="perfil-ingresos__doc-slot">
                    <input #docInput class="perfil-cedula__input" type="file"
                      [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label"
                      (change)="onDocSelected(next.slotKey, $event)" />
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-ingresos__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + next.slotKey"
                      (click)="openDocModalFor(doc, docInput, next.slotKey)">
                      <span>{{ multiUploadCta(doc) }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                  </div>
                  }
                  } @else {
                  @for (slot of slotsFor(doc); track slot.slotKey) {
                  <div class="perfil-ingresos__doc-slot">
                    <input #docInput class="perfil-cedula__input" type="file"
                      [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label"
                      (change)="onDocSelected(slot.slotKey, $event)" />

                    @if (!hasSlotDoc(slot.slotKey)) {
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-ingresos__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + slot.slotKey"
                      (click)="openDocModalFor(doc, docInput, slot.slotKey)">
                      <span>{{ copy.sobreIngresos.cargarArchivo }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                    } @else {
                    <div class="perfil-ingresos__file-card" role="status"
                      [class.perfil-ingresos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                      [class.perfil-ingresos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                      [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreIngresos.validaciones.documentosInconsistentes) : ''"
                      container="body">
                      <div class="perfil-ingresos__file-icon-wrap">
                        <img class="perfil-ingresos__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                      </div>
                      <div class="perfil-ingresos__file-meta">
                        <div class="perfil-ingresos__file-top">
                          <p class="perfil-ingresos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                          @if (canRemoveSlot(slot.slotKey)) {
                          <button type="button" class="perfil-ingresos__file-remove"
                            [attr.aria-label]="copy.sobreIngresos.archivoQuitar"
                            (click)="removeDoc(slot.slotKey, docInput)">
                            <span class="material-icons" aria-hidden="true">close</span>
                          </button>
                          }
                        </div>
                        <p class="perfil-ingresos__file-status">
                          <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                          <span aria-hidden="true"> • </span>
                          <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                        </p>
                        @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                        <p class="perfil-ingresos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                        }
                      </div>
                    </div>
                    }
                  </div>
                  }
                  }
                </div>

                @if (isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)) {
                <p class="perfil-field__error perfil-ingresos__error">{{
                  errorMessage(doc.valueKey)
                }}</p>
                }
              </div>
              }

              @if (!esExpress && !esJuridica && docDeclaracionRenta) {
              <div class="perfil-ingresos__renta"
                [class.perfil-ingresos__renta--with-doc]="muestraDocDeclaracionRenta">
                @if (muestraPreguntaDeclaraRenta) {
                <div class="perfil-field perfil-field--required"
                  [class.perfil-field--invalid]="isInvalid('declaraRenta')">
                  <span class="perfil-field__label" id="lbl-declara-renta">{{
                    copy.sobreIngresos.campos.declaraRenta
                    }}</span>
                  <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-declara-renta">
                    <label class="perfil-radio">
                      <input type="radio" formControlName="declaraRenta" value="si" />
                      <span>{{ copy.sobreIngresos.campos.si }}</span>
                    </label>
                    <label class="perfil-radio">
                      <input type="radio" formControlName="declaraRenta" value="no" />
                      <span>{{ copy.sobreIngresos.campos.no }}</span>
                    </label>
                  </div>
                  @if (isInvalid('declaraRenta')) {
                  <p class="perfil-field__error">{{ errorMessage('declaraRenta') }}</p>
                  }
                </div>
                }

                @if (muestraDocDeclaracionRenta && docDeclaracionRenta; as doc) {
                <div class="perfil-ingresos__doc perfil-ingresos__doc--renta"
                  [class.perfil-ingresos__doc--loaded]="hasDoc(doc.valueKey)"
                  [class.perfil-ingresos__doc--invalid]="isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)"
                  [class.perfil-ingresos__doc--multi]="doc.multiple">
                  <div class="perfil-ingresos__doc-text">
                    <p class="perfil-ingresos__doc-title perfil-field--required">
                      <span class="perfil-field__label">{{ labelDocRenta(doc) }}</span>
                    </p>
                    @if (doc.descripcion || copy.sobreIngresos.docs.declaracionRenta.description) {
                    <p class="perfil-ingresos__doc-desc">{{
                      doc.descripcion || copy.sobreIngresos.docs.declaracionRenta.description
                      }}</p>
                    }
                  </div>

                  <div class="perfil-ingresos__doc-slots"
                    [class.perfil-ingresos__doc-slots--multi]="isDocMultiple(doc)">
                    @if (isDocMultiple(doc)) {
                    <div class="perfil-ingresos__doc-multi-head">
                      <span class="perfil-ingresos__doc-multi-hint">{{ multiUploadHint(doc) }}</span>
                      <span class="perfil-ingresos__doc-multi-count">{{ filledSlotsCount(doc) }} de {{ maxSlotsCount(doc) }}</span>
                    </div>

                    @for (slot of filledSlots(doc); track slot.slotKey) {
                    <div class="perfil-ingresos__file-card" role="status"
                      [class.perfil-ingresos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                      [class.perfil-ingresos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                      [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreIngresos.validaciones.documentosInconsistentes) : ''"
                      container="body">
                      <div class="perfil-ingresos__file-icon-wrap">
                        <img class="perfil-ingresos__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                      </div>
                      <div class="perfil-ingresos__file-meta">
                        <div class="perfil-ingresos__file-top">
                          <p class="perfil-ingresos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                          @if (canRemoveSlot(slot.slotKey)) {
                          <button type="button" class="perfil-ingresos__file-remove"
                            [attr.aria-label]="copy.sobreIngresos.archivoQuitar"
                            (click)="removeDoc(slot.slotKey)">
                            <span class="material-icons" aria-hidden="true">close</span>
                          </button>
                          }
                        </div>
                        <p class="perfil-ingresos__file-status">
                          <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                          <span aria-hidden="true"> • </span>
                          <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                        </p>
                        @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                        <p class="perfil-ingresos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                        }
                      </div>
                    </div>
                    }

                    @if (nextEmptySlot(doc); as next) {
                    <div class="perfil-ingresos__doc-slot">
                      <input #docInput class="perfil-cedula__input" type="file"
                        [accept]="acceptFor(doc)"
                        [attr.aria-label]="doc.label"
                        (change)="onDocSelected(next.slotKey, $event)" />
                      <button type="button" class="perfil-btn perfil-btn--upload perfil-ingresos__upload-btn"
                        [attr.id]="'btn-perfil-doc-' + next.slotKey"
                        (click)="openDocModalFor(doc, docInput, next.slotKey)">
                        <span>{{ multiUploadCta(doc) }}</span>
                        <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                      </button>
                    </div>
                    }
                    } @else {
                    @for (slot of slotsFor(doc); track slot.slotKey) {
                    <div class="perfil-ingresos__doc-slot">
                      <input #docInput class="perfil-cedula__input" type="file"
                        [accept]="acceptFor(doc)"
                        [attr.aria-label]="doc.label"
                        (change)="onDocSelected(slot.slotKey, $event)" />

                      @if (!hasSlotDoc(slot.slotKey)) {
                      <button type="button" class="perfil-btn perfil-btn--upload perfil-ingresos__upload-btn"
                        [attr.id]="'btn-perfil-doc-' + slot.slotKey"
                        (click)="openDocModalFor(doc, docInput, slot.slotKey)">
                        <span>{{ copy.sobreIngresos.cargarArchivo }}</span>
                        <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                      </button>
                      } @else {
                      <div class="perfil-ingresos__file-card" role="status"
                        [class.perfil-ingresos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                        [class.perfil-ingresos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                        [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreIngresos.validaciones.documentosInconsistentes) : ''"
                        container="body">
                        <div class="perfil-ingresos__file-icon-wrap">
                          <img class="perfil-ingresos__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                        </div>
                        <div class="perfil-ingresos__file-meta">
                          <div class="perfil-ingresos__file-top">
                            <p class="perfil-ingresos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                            @if (canRemoveSlot(slot.slotKey)) {
                            <button type="button" class="perfil-ingresos__file-remove"
                              [attr.aria-label]="copy.sobreIngresos.archivoQuitar"
                              (click)="removeDoc(slot.slotKey, docInput)">
                              <span class="material-icons" aria-hidden="true">close</span>
                            </button>
                            }
                          </div>
                          <p class="perfil-ingresos__file-status">
                            <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                            <span aria-hidden="true"> • </span>
                            <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                          </p>
                          @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                          <p class="perfil-ingresos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                          }
                        </div>
                      </div>
                      }
                    </div>
                    }
                    }
                  </div>

                  @if (isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)) {
                  <p class="perfil-field__error perfil-ingresos__error">{{
                    errorMessage(doc.valueKey)
                    }}</p>
                  }
                </div>
                }
              </div>
              }
            </div>
            }

            @if (currentStepId === 'activos-soportes') {
            <div class="perfil-ingresos__auth" [class.perfil-ingresos__auth--invalid]="isInvalid('autorizacionCentrales')">
              <label class="perfil-ingresos__auth-check" for="autorizacionCentrales">
                <input id="autorizacionCentrales" class="perfil-ingresos__auth-input" type="checkbox"
                  formControlName="autorizacionCentrales" />
                <span class="perfil-ingresos__auth-box" aria-hidden="true">
                  <img class="perfil-ingresos__auth-icon" [src]="checkIcon" alt="" width="12" height="9" />
                </span>
              </label>
              <p class="perfil-ingresos__auth-text">
                {{ copy.sobreIngresos.autorizacionPrefijo }}<button type="button" class="perfil-ingresos__auth-em"
                  data-bs-toggle="modal" data-bs-target="#politicasModal" (click)="openPoliticasCentrales()">{{
                  copy.sobreIngresos.autorizacionEnlace
                  }}</button>
              </p>
              @if (isInvalid('autorizacionCentrales')) {
              <p class="perfil-field__error">{{ errorMessage('autorizacionCentrales') }}</p>
              }
            </div>
            }
          </div>
          }

          @if (currentStepId === 'flujo-caja') {
          <div class="perfil-flujo">
            <div class="perfil-flujo__panels">
              <div class="perfil-flujo__panel perfil-flujo__panel--ingresos"
                [class.perfil-flujo__panel--open]="panelIngresosOpen">
                <button type="button" class="perfil-flujo__head perfil-flujo__head--ingresos"
                  [attr.aria-expanded]="panelIngresosOpen" (click)="togglePanelIngresos()">
                  <span class="perfil-flujo__head-left">
                    <img class="perfil-flujo__head-icon" [src]="iconIngresos" alt="" width="32" height="32" />
                    <span class="perfil-flujo__head-title">{{ copy.sobreIngresos.totalIngresos }}</span>
                  </span>
                  <span class="perfil-flujo__head-right">
                    <span class="perfil-flujo__head-amount">{{ totalIngresosLabel }}</span>
                    <span class="material-icons perfil-flujo__chevron" aria-hidden="true">{{
                      panelIngresosOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                      }}</span>
                  </span>
                </button>

                <div class="perfil-flujo__body" [class.perfil-field--hidden]="!panelIngresosOpen">
                  <div class="perfil-section-page__grid perfil-section-page__grid--2">
                    <div class="perfil-field perfil-field--required"
                      [class.perfil-field--invalid]="isInvalid('mesReporte')">
                      <label class="perfil-field__label" for="mesReporte">{{
                        copy.sobreIngresos.campos.mesReporte
                        }}</label>
                      <select id="mesReporte" class="perfil-field__control" formControlName="mesReporte"
                        [class.perfil-field__control--invalid]="isInvalid('mesReporte')">
                        <option value="">{{ copy.sobreIngresos.placeholderSelect }}</option>
                        @for (mes of mesesMock; track mes) {
                        <option [value]="mes">{{ mes }}</option>
                        }
                      </select>
                      @if (isInvalid('mesReporte')) {
                      <p class="perfil-field__error">{{ errorMessage('mesReporte') }}</p>
                      }
                    </div>

                    <div class="perfil-field perfil-field--required"
                      [class.perfil-field--invalid]="isInvalid('ventasUltimoMes')">
                      <label class="perfil-field__label" for="ventasUltimoMes">{{ ventasLabel }}</label>
                      <input id="ventasUltimoMes" class="perfil-field__control" type="text" inputmode="numeric"
                        autocomplete="off" formControlName="ventasUltimoMes"
                        [placeholder]="copy.sobreIngresos.placeholderMoneda"
                        [class.perfil-field__control--invalid]="isInvalid('ventasUltimoMes')"
                        (input)="onMonedaInput('ventasUltimoMes', $event)" (blur)="onMonedaBlur('ventasUltimoMes')" />
                      @if (isInvalid('ventasUltimoMes')) {
                      <p class="perfil-field__error">{{ errorMessage('ventasUltimoMes') }}</p>
                      }
                    </div>

                    <div class="perfil-field">
                      <label class="perfil-field__label" for="otrosIngresos">{{
                        copy.sobreIngresos.campos.otrosIngresos
                        }}</label>
                      <input id="otrosIngresos" class="perfil-field__control" type="text" inputmode="numeric"
                        autocomplete="off" formControlName="otrosIngresos"
                        [placeholder]="copy.sobreIngresos.placeholderTexto"
                        (input)="onMonedaInput('otrosIngresos', $event)" (blur)="onMonedaBlur('otrosIngresos')" />
                    </div>

                    <div class="perfil-field">
                      <label class="perfil-field__label" for="fuenteOtrosIngresos">{{
                        copy.sobreIngresos.campos.fuenteOtrosIngresos
                        }}</label>
                      <input id="fuenteOtrosIngresos" class="perfil-field__control" type="text"
                        formControlName="fuenteOtrosIngresos" [placeholder]="copy.sobreIngresos.placeholderTexto" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="perfil-flujo__panel perfil-flujo__panel--gastos"
                [class.perfil-flujo__panel--open]="panelGastosOpen">
                <button type="button" class="perfil-flujo__head perfil-flujo__head--gastos"
                  [attr.aria-expanded]="panelGastosOpen" (click)="togglePanelGastos()">
                  <span class="perfil-flujo__head-left">
                    <img class="perfil-flujo__head-icon" [src]="iconGastos" alt="" width="32" height="32" />
                    <span class="perfil-flujo__head-title">{{ copy.sobreIngresos.totalGastos }}</span>
                  </span>
                  <span class="perfil-flujo__head-right">
                    <span class="perfil-flujo__head-amount">{{ totalGastosLabel }}</span>
                    <span class="material-icons perfil-flujo__chevron" aria-hidden="true">{{
                      panelGastosOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                      }}</span>
                  </span>
                </button>

                <div class="perfil-flujo__body" [class.perfil-field--hidden]="!panelGastosOpen">
                  <div class="perfil-flujo__modo" role="group" aria-label="Tipo de gastos">
                    <button type="button" class="perfil-flujo__modo-label"
                      [class.perfil-flujo__modo-label--active]="esGastosGenerales" (click)="setModoGastos('generales')">
                      {{ copy.sobreIngresos.gastosGenerales }}
                    </button>
                    <button type="button" class="perfil-flujo__modo-switch"
                      [class.perfil-flujo__modo-switch--especificos]="esGastosEspecificos"
                      [attr.aria-checked]="esGastosEspecificos" role="switch"
                      (click)="setModoGastos(esGastosEspecificos ? 'generales' : 'especificos')">
                      <span class="perfil-flujo__modo-thumb" aria-hidden="true"></span>
                    </button>
                    <button type="button" class="perfil-flujo__modo-label"
                      [class.perfil-flujo__modo-label--active]="esGastosEspecificos"
                      (click)="setModoGastos('especificos')">
                      {{ copy.sobreIngresos.gastosEspecificos }}
                    </button>
                  </div>

                  <div class="perfil-flujo__modo-panel" [class.perfil-field--hidden]="!esGastosGenerales">
                    <div class="perfil-field perfil-field--required"
                      [class.perfil-field--invalid]="isInvalid('gastosGeneralesMonto')">
                      <label class="perfil-field__label" for="gastosGeneralesMonto">{{
                        copy.sobreIngresos.campos.gastosGeneralesMonto
                        }}</label>
                      <input id="gastosGeneralesMonto" class="perfil-field__control" type="text" inputmode="numeric"
                        autocomplete="off" formControlName="gastosGeneralesMonto"
                        [placeholder]="copy.sobreIngresos.placeholderMoneda"
                        [class.perfil-field__control--invalid]="isInvalid('gastosGeneralesMonto')"
                        (input)="onMonedaInput('gastosGeneralesMonto', $event)"
                        (blur)="onMonedaBlur('gastosGeneralesMonto')" />
                      @if (isInvalid('gastosGeneralesMonto')) {
                      <p class="perfil-field__error">{{ errorMessage('gastosGeneralesMonto') }}</p>
                      }
                    </div>
                  </div>

                  <div class="perfil-flujo__modo-panel" [class.perfil-field--hidden]="!esGastosEspecificos">
                    <div class="perfil-section-page__grid perfil-section-page__grid--2">
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="pagoProveedores">{{
                          copy.sobreIngresos.campos.pagoProveedores
                          }}</label>
                        <input id="pagoProveedores" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="pagoProveedores"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('pagoProveedores', $event)" (blur)="onMonedaBlur('pagoProveedores')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="arriendo">{{
                          copy.sobreIngresos.campos.arriendo
                          }}</label>
                        <input id="arriendo" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="arriendo"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('arriendo', $event)" (blur)="onMonedaBlur('arriendo')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="administracion">{{
                          copy.sobreIngresos.campos.administracion
                          }}</label>
                        <input id="administracion" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="administracion"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('administracion', $event)" (blur)="onMonedaBlur('administracion')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="serviciosPublicosNegocio">{{
                          copy.sobreIngresos.campos.serviciosPublicosNegocio
                          }}</label>
                        <input id="serviciosPublicosNegocio" class="perfil-field__control" type="text"
                          inputmode="numeric" autocomplete="off" formControlName="serviciosPublicosNegocio"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('serviciosPublicosNegocio', $event)"
                          (blur)="onMonedaBlur('serviciosPublicosNegocio')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="sueldoPropio">{{
                          copy.sobreIngresos.campos.sueldoPropio
                          }}</label>
                        <input id="sueldoPropio" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="sueldoPropio"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('sueldoPropio', $event)" (blur)="onMonedaBlur('sueldoPropio')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="sueldoEmpleados">{{
                          copy.sobreIngresos.campos.sueldoEmpleados
                          }}</label>
                        <input id="sueldoEmpleados" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="sueldoEmpleados"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('sueldoEmpleados', $event)" (blur)="onMonedaBlur('sueldoEmpleados')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="planCelular">{{
                          copy.sobreIngresos.campos.planCelular
                          }}</label>
                        <input id="planCelular" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="planCelular"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('planCelular', $event)" (blur)="onMonedaBlur('planCelular')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="tarjetaCredito">{{
                          copy.sobreIngresos.campos.tarjetaCredito
                          }}</label>
                        <input id="tarjetaCredito" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="tarjetaCredito"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('tarjetaCredito', $event)" (blur)="onMonedaBlur('tarjetaCredito')" />
                      </div>
                    </div>

                    <div class="perfil-field perfil-flujo__creditos">
                      <span class="perfil-field__label" id="lbl-tiene-creditos">{{
                        copy.sobreIngresos.campos.tieneCreditos
                        }}</span>
                      <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-tiene-creditos">
                        <label class="perfil-radio">
                          <input type="radio" formControlName="tieneCreditos" value="si" />
                          <span>{{ copy.sobreIngresos.campos.si }}</span>
                        </label>
                        <label class="perfil-radio">
                          <input type="radio" formControlName="tieneCreditos" value="no" />
                          <span>{{ copy.sobreIngresos.campos.no }}</span>
                        </label>
                      </div>
                    </div>

                    <div class="perfil-section-page__grid perfil-section-page__grid--2"
                      [class.perfil-field--hidden]="!muestraCreditosDetalle">
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="cuotaCreditos">{{
                          copy.sobreIngresos.campos.cuotaCreditos
                          }}</label>
                        <input id="cuotaCreditos" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="cuotaCreditos"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('cuotaCreditos', $event)" (blur)="onMonedaBlur('cuotaCreditos')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="saldoDeudas">{{
                          copy.sobreIngresos.campos.saldoDeudas
                          }}</label>
                        <input id="saldoDeudas" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="saldoDeudas"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('saldoDeudas', $event)" (blur)="onMonedaBlur('saldoDeudas')" />
                      </div>
                    </div>

                    <div class="perfil-section-page__grid perfil-section-page__grid--2">
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="otrosGastos">{{
                          copy.sobreIngresos.campos.otrosGastos
                          }}</label>
                        <input id="otrosGastos" class="perfil-field__control" type="text" inputmode="numeric"
                          autocomplete="off" formControlName="otrosGastos"
                          [placeholder]="copy.sobreIngresos.placeholderTexto"
                          (input)="onMonedaInput('otrosGastos', $event)" (blur)="onMonedaBlur('otrosGastos')" />
                      </div>
                      <div class="perfil-field">
                        <label class="perfil-field__label" for="fuenteOtrosGastos">{{
                          copy.sobreIngresos.campos.fuenteOtrosGastos
                          }}</label>
                        <input id="fuenteOtrosGastos" class="perfil-field__control" type="text"
                          formControlName="fuenteOtrosGastos" [placeholder]="copy.sobreIngresos.placeholderTexto" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="perfil-flujo__resumen" aria-live="polite">
              <div class="perfil-flujo__resumen-card perfil-flujo__resumen-card--ingresos">
                <img class="perfil-flujo__resumen-icon" [src]="iconIngresos" alt="" width="32" height="32" />
                <div class="perfil-flujo__resumen-text">
                  <p class="perfil-flujo__resumen-label">{{ copy.sobreIngresos.resumenIngresos }}</p>
                  <p class="perfil-flujo__resumen-amount">{{ totalIngresosLabel }}</p>
                </div>
              </div>
              <div class="perfil-flujo__resumen-card perfil-flujo__resumen-card--gastos">
                <img class="perfil-flujo__resumen-icon" [src]="iconGastos" alt="" width="32" height="32" />
                <div class="perfil-flujo__resumen-text">
                  <p class="perfil-flujo__resumen-label">{{ copy.sobreIngresos.resumenGastos }}</p>
                  <p class="perfil-flujo__resumen-amount">{{ totalGastosLabel }}</p>
                </div>
              </div>
              <span class="perfil-flujo__resumen-eq" aria-hidden="true">=</span>
              <div class="perfil-flujo__resumen-card perfil-flujo__resumen-card--efectivo">
                <img class="perfil-flujo__resumen-icon" [src]="iconEfectivo" alt="" width="32" height="32" />
                <div class="perfil-flujo__resumen-text">
                  <p class="perfil-flujo__resumen-label">{{ copy.sobreIngresos.efectivoDisponible }}</p>
                  <p class="perfil-flujo__resumen-amount">{{ efectivoDisponibleLabel }}</p>
                </div>
              </div>
            </div>
          </div>
          }

          @if (currentStepId === 'info-adicional') {
          <div class="perfil-opcionales-ingresos">
            <div class="perfil-opcionales-ingresos__intro">
              <h2 class="perfil-opcionales-ingresos__title">{{
                copy.sobreIngresos.infoAdicionalHeading
                }}</h2>
              <p class="perfil-opcionales-ingresos__hint">{{
                copy.sobreIngresos.infoAdicionalHint
                }}</p>
            </div>

            <div class="perfil-opcionales-ingresos__content">
              @for (doc of documentosPasoInfoSinRenta; track doc.valueKey) {
              <div class="perfil-ingresos__doc"
                [class.perfil-ingresos__doc--loaded]="hasDoc(doc.valueKey)"
                [class.perfil-ingresos__doc--invalid]="isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)"
                [class.perfil-ingresos__doc--multi]="doc.multiple">
                <div class="perfil-ingresos__doc-text">
                  <p class="perfil-ingresos__doc-title" [class.perfil-field--required]="doc.obligatorio">
                    <span class="perfil-field__label">{{ labelDoc(doc) }}</span>
                  </p>
                  @if (doc.descripcion) {
                  <p class="perfil-ingresos__doc-desc">{{ doc.descripcion }}</p>
                  }
                </div>
                <div class="perfil-ingresos__doc-slots"
                  [class.perfil-ingresos__doc-slots--multi]="isDocMultiple(doc)">
                  @if (isDocMultiple(doc)) {
                  <div class="perfil-ingresos__doc-multi-head">
                    <span class="perfil-ingresos__doc-multi-hint">{{ multiUploadHint(doc) }}</span>
                    <span class="perfil-ingresos__doc-multi-count">{{ filledSlotsCount(doc) }} de {{ maxSlotsCount(doc) }}</span>
                  </div>

                  @for (slot of filledSlots(doc); track slot.slotKey) {
                  <div class="perfil-ingresos__file-card" role="status"
                    [class.perfil-ingresos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                    [class.perfil-ingresos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                    [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreIngresos.validaciones.documentosInconsistentes) : ''"
                    container="body">
                    <div class="perfil-ingresos__file-icon-wrap">
                      <img class="perfil-ingresos__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                    </div>
                    <div class="perfil-ingresos__file-meta">
                      <div class="perfil-ingresos__file-top">
                        <p class="perfil-ingresos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                        @if (canRemoveSlot(slot.slotKey)) {
                        <button type="button" class="perfil-ingresos__file-remove"
                          [attr.aria-label]="copy.sobreIngresos.archivoQuitar"
                          (click)="removeDoc(slot.slotKey)">
                          <span class="material-icons" aria-hidden="true">close</span>
                        </button>
                        }
                      </div>
                      <p class="perfil-ingresos__file-status">
                        <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                        <span aria-hidden="true"> • </span>
                        <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                      </p>
                      @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                      <p class="perfil-ingresos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                      }
                    </div>
                  </div>
                  }

                  @if (nextEmptySlot(doc); as next) {
                  <div class="perfil-ingresos__doc-slot">
                    <input #docExtraInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(next.slotKey, $event)" />
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-ingresos__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + next.slotKey"
                      (click)="openDocModalFor(doc, docExtraInput, next.slotKey)">
                      <span>{{ multiUploadCta(doc) }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                  </div>
                  }
                  } @else {
                  @for (slot of slotsFor(doc); track slot.slotKey) {
                  <div class="perfil-ingresos__doc-slot">
                    <input #docExtraInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(slot.slotKey, $event)" />
                    @if (!hasSlotDoc(slot.slotKey)) {
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-ingresos__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + slot.slotKey"
                      (click)="openDocModalFor(doc, docExtraInput, slot.slotKey)">
                      <span>{{ copy.sobreIngresos.cargarArchivo }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                    } @else {
                    <div class="perfil-ingresos__file-card" role="status"
                      [class.perfil-ingresos__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                      [class.perfil-ingresos__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                      [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreIngresos.validaciones.documentosInconsistentes) : ''"
                      container="body">
                      <div class="perfil-ingresos__file-icon-wrap">
                        <img class="perfil-ingresos__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                      </div>
                      <div class="perfil-ingresos__file-meta">
                        <div class="perfil-ingresos__file-top">
                          <p class="perfil-ingresos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                          @if (canRemoveSlot(slot.slotKey)) {
                          <button type="button" class="perfil-ingresos__file-remove"
                            [attr.aria-label]="copy.sobreIngresos.archivoQuitar"
                            (click)="removeDoc(slot.slotKey, docExtraInput)">
                            <span class="material-icons" aria-hidden="true">close</span>
                          </button>
                          }
                        </div>
                        <p class="perfil-ingresos__file-status">
                          <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                          <span aria-hidden="true"> • </span>
                          <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                        </p>
                        @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                        <p class="perfil-ingresos__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                        }
                      </div>
                    </div>
                    }
                  </div>
                  }
                  }
                </div>
                @if (isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)) {
                <p class="perfil-field__error perfil-ingresos__error">{{ errorMessage(doc.valueKey) }}</p>
                }
              </div>
              }

              <div class="perfil-field perfil-opcionales-ingresos__obs">
                <label class="perfil-field__label perfil-opcionales-ingresos__field-label" for="observaciones">{{
                  copy.sobreIngresos.campos.observaciones
                  }}</label>
                <textarea id="observaciones" class="perfil-field__control perfil-opcionales-ingresos__textarea"
                  formControlName="observaciones" rows="4"
                  [placeholder]="copy.sobreIngresos.placeholderObservaciones"></textarea>
              </div>
            </div>
          </div>
          }
        </form>
      </div>
    </div>
  </div>

  <app-perfil-section-footer perfilSectionFooter variant="necesidad" seccionId="sobre-ingresos" [showSaltar]="true"
    [ctaLabelOverride]="ctaLabel" [continuarDisabled]="continuarDisabled" (saltar)="onSaltar()"
    (continuar)="onCta()"></app-perfil-section-footer>
</app-perfil-shell>

<app-perfil-intro-modal [open]="introModalOpen" seccionId="sobre-ingresos" [segmento]="segmentoIntro"
  [juridica]="esJuridica" (closed)="closeIntroModal()"
  (completarDatos)="onIntroCompletarDatos()"></app-perfil-intro-modal>

<app-perfil-documento-modal [open]="docModalOpen" [config]="docModalConfig" (closed)="closeDocModal()"
  (subir)="onSubirDesdeDocModal()"></app-perfil-documento-modal>

<app-perfil-salir-modal [open]="salirModalOpen" (closed)="closeSalirModal()"
  (guardar)="onSalirGuardar()"></app-perfil-salir-modal>

<politicas-modal [title]="titlePoliticasModal"></politicas-modal>